import { Dialog as BaseUiDialog } from '@base-ui-components/react/dialog';
import { twMerge } from 'tailwind-merge';

import Button, { type ButtonProps } from './button';

export interface DialogTriggerProps extends ButtonProps {}

function DialogTrigger({ className, ...props }: DialogTriggerProps) {
  return (
    <Button
      {...props}
      className={twMerge('gooey-dialog-trigger', className)}
      component={BaseUiDialog.Trigger}
    />
  );
}
DialogTrigger.displayName = 'GooeyDialogTrigger';

export default DialogTrigger;
